<script lang="ts">
    export let id:string;
    export let functions: any;

    import Input from '../components/input.svelte';
    import InputCheckbox from '../components/input-checkbox.svelte';
    import Icons from '../components/icons.svelte';
    import InputNumber from '../components/input-number.svelte';
    import Button from '../components/button.svelte';
    import {appState, familiesS, lightnessParamsS, prefs } from '../stores';
    import TabIcon from '../components/tab-icon.svelte';
    import Select from '../components/select.svelte';
    import Divider from '../components/divider.svelte';
    import Callout from '../components/callout.svelte';

    // find the index of the correct family
    // $: index = functions.getFamilyIndex(id);
    $: index = $appState.familySelectedIndex;

    let familyNameID:string;
    $: warning = '';
    $: if ($familiesS[index] !== undefined) {
        familyNameID = $familiesS[index].name.toLowerCase().replace(/\s/g, '_');
        warning = $familiesS[index].anchorValidity ? '' : 'Invalid hex code';
    }

    // logic to disable or enable move buttons
    $: moveUp = index === 0;
    $: moveDown = index === $familiesS.length - 1;

    let saturationLabel = 'Saturation'
    $: if ($prefs.colorSpace === 'HCT') {
        saturationLabel = 'Chroma';
    } else {
        saturationLabel = 'Saturation';
    }

</script>

{#if $familiesS[index] !== undefined}
<div class="info-area" class:active={$appState.family === id && $appState.familySelected}>
    <div class="family-title-area">
        <Input name={familyNameID} bind:value={$familiesS[index].name} label={'Name'}  on:message={() => functions.update(id, true, 'name')} role={'family-name'}/>
        <Button label="" icon="x" handleClick={() => functions.manageAppState('family', '-1')} role="tertiary" ariaLabel="Hide color family controls" roundedCorners={false} />
    </div>

    <div class="options-area">
        <div class="tab-area" role="tablist">
            <TabIcon label="Base" selected={$appState.familyOption === 0} handleClick={() => {functions.manageAppState('familyOption', 0)}} tabid={'family-tab-0'} tabStyleUnderlined={true}/>
            <TabIcon label="Modulation" selected={$appState.familyOption === 1} handleClick={() => {functions.manageAppState('familyOption', 1)}} tabid={'family-tab-1'} tabStyleUnderlined={true} />
            <TabIcon label="Options" selected={$appState.familyOption === 2} handleClick={() => {functions.manageAppState('familyOption', 2)}} tabid={'family-tab-2'} tabStyleUnderlined={true} />
        </div>

        {#if $appState.familyOption === 0}
            <div class="subsection" role="tabpanel" aria-labelledby="family-tab-0">
                <InputCheckbox label="Use anchor color" name={'anchor-pref-' + id} bind:checked={$familiesS[index].anchorPref} disabled={false} on:message={() => functions.toggleAnchorState(id, $familiesS[index].anchor)} />
                {#if $familiesS[index].anchorPref}
                    <Input name={familyNameID + '_anchor'} bind:value={$familiesS[index].anchor} label={'Anchor color hex'} placeholder={'fff000'} on:message={() => functions.newAnchor(id, $familiesS[index].anchor)} warning={warning} maxChars={6} />
                {/if}
                {#if $familiesS[index].swatchGroup.length !== $lightnessParamsS.steps}
                    <Callout icon="alert">
                        <div class="text-block"><p>This anchor color is not aligned with your global lightness/tone settings. Be aware it will add an extra step.</p></div>
                    </Callout>
                {/if}
    
                {#if !$familiesS[index].anchorPref}
                    <InputNumber name={familyNameID + '_hue'} bind:value={$familiesS[index].hue} label={'Hue'} max={360} on:message={() => functions.update(id, false, 'hue')} style={'hue'} />
                    <InputNumber name={familyNameID + '_saturation'} bind:value={$familiesS[index].saturation} max={$prefs.colorSpace === 'HCT' ? 150 : 100} label={saturationLabel}  on:message={() => functions.update(id, false, 'saturation')} />
                    <div class="button-group" >
                        <Button label="Randomize" handleClick={() => {functions.randomize(id)}} role="secondary" buttonGroup />
                    </div>
                {/if}
            </div>
        {/if}

        {#if $appState.familyOption === 1}
            <div class="subsection" role="tabpanel" aria-labelledby="family-tab-1">
                <InputCheckbox label="Hue shift" name={'hue-shift-pref-' + id} bind:checked={$familiesS[index].hueShift} on:message={() => functions.toggleModulation(id, 'hueShift')}/>
                {#if $familiesS[index].hueShift}
                    <!-- <Select label="Method" name={'hue-shift-method-' + id} options={['Polar opposites', 'Polar sync']} bind:value={$familiesS[index].hueShiftMethod} /> -->
                    <InputNumber label="Amount" name={'hue-shift-amount-' + id} min={-1} max={1} step={0.01} bind:value={$familiesS[index].hueShiftAmount} on:message={() => functions.update(id, false, 'modulation')} />
                    <Divider />
                {/if}
                <InputCheckbox label="{saturationLabel} shift" name={'saturation-shift-pref-' + id} bind:checked={$familiesS[index].saturationShift} on:message={() => functions.toggleModulation(id, 'saturationShift')}/>
                {#if $familiesS[index].saturationShift}
                    <!-- <Select label="Method" name={'saturation-shift-method-' + id} options={['Polar opposites', 'Polar sync']} bind:value={$familiesS[index].saturationShiftMethod} /> -->
                    <InputNumber label="Amount" name={'saturation-shift-amount-' + id} min={-1} max={1} step={0.01} bind:value={$familiesS[index].saturationShiftAmount} on:message={() => functions.update(id, false, 'modulation')} />
                    <Divider />
                {/if}
            </div>
        {/if}
        
        {#if $appState.familyOption === 2}
            <div class="subsection" role="tabpanel" aria-labelledby="family-tab-2">
                <h4>Position ({index + 1})</h4>
                <div class="button-group">
                    <Button label="" handleClick={() => {functions.move(true, id)}} role="tertiary" disabled={moveUp} icon={'carret up'} />
                    <Button label="" handleClick={() => {functions.move(false, id)}} role="tertiary" disabled={moveDown} icon={'carret down'} />
                </div>
            </div>

            <div class="subsection">
                <div class="button-group" >
                    <Button label="Delete family" handleClick={() => {$appState.modalOpen = true}} role="secondary" buttonGroup />    
                </div>
            </div>
        {/if}
    </div>
</div>
{/if}

<style>
    p {
        line-height: 1.5;
        margin: 0.5rem 0;
    }
    .family-title-area {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 1rem;
    }
    .tab-area {
        display: flex;
    }
    .subsection {
        margin: 1rem 1rem 3rem 1rem;
    }

    .info-area {
        pointer-events: none;
        visibility: none;
        height: 100%;
    }
    .info-area.active {
        pointer-events: all;
        visibility: visible;
        border-left: 1px solid var(--background-offset);
    }
    .button-group {
        margin-bottom: 1rem;
    }
    @media (max-width: 960px) {
        .info-area {
            position: fixed;
            z-index: 4;
            top: 100vh;
            left: 0;
            width: 100vw;
            height: calc(75vh -56px);
            background-color: var(--background);
            transition: 0.3s;
            
            box-sizing: border-box;
        }
    
        .info-area.active {
            top: calc(25vh + 56px);
            height: calc(75vh - 56px);
        }
        .family-title-area {
            display: flex;
            align-items: center;
            justify-content: space-between;
            /* padding: 1rem 1rem 0.25rem 1rem; */
        }
        .options-area {
            padding-top: 1rem;
            height: calc(100% - 80px); /* subtract the height of the title area */
            overflow-y: scroll;
        }
    }
</style>